<template>
  <el-form-item label="城市名称">
    <el-select
      v-model="searchForm.city_id"
      placeholder="请选择"
      clearable
      size="mini"
      @change="getdata"
    >
      <el-option
        v-for="item in cityList"
        :key="item.id"
        :label="item.title"
        :value="item.id"
      />
    </el-select>
  </el-form-item>
</template>
<script>
import { getCityeList } from "../api/city";
export default {
  data() {
    return {
      // 搜索表单
      searchForm: {},
      // 城市列表
      cityList: "",
    };
  },
  mounted() {
    this.getCityeLists();
  },
  methods: {
    // 城市下拉
    getCityeLists() {
      getCityeList().then((res) => {
        this.cityList = res.data.data;
      });
    },
    getdata(res) {
      this.$emit("getCityData", res);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/citySearch.vue